import { TargetFinancialStatement } from "../CommonModel/TargetFinancialStatement";
import { DatePeriod } from "../CommonModel/BaseModel";
import { BaseRequestModel } from "./BaseRequestModel";
import { CookieAuthenModel } from "../CommonModel/CookieAuthenModel";
import { storageModel } from "../CommonModel/StorageModel";
import { FinancialStatementTypes } from "../ResponseModel/FiscalPeriodResponseModel";
import { SelectedFiscalPeriodStateModel } from "../StateModel/FiscalPeriodInfoStateModel";
import { ConsolidateType } from "./TransferValuesRequestModel";

export class TransferStructuresRequestModel {
    constructor(obj) {
        this.CompanyId = obj.CompanyId;
        this.TransferStructuresRequest = new TransferStructuresRequest(obj.TransferStructuresRequest);
        this.ApprovalFlowStatus = obj.ApprovalFlowStatus;
    }
}

export class TransferStructuresRequest extends BaseRequestModel {
    constructor(obj) {
        super(obj);
        this.PeriodicAccountingItemGroups = obj.PeriodicAccountingItemGroups.map((item) => new PeriodicAccountingItemGroup(item));
    }
}

export class PeriodicAccountingItemGroup {
    constructor(obj) {
        this.YearToDate = new DatePeriod(obj.YearToDate);
        this.AccountingPeriod = new DatePeriod(obj.AccountingPeriod);
        this.TargetFinancialStatement = new TargetFinancialStatement(obj.TargetFinancialStatement);
        this.AccountingItems = null;
        this.PresentationStructure = null;
        this.CalculationStructure = null;
    }
}

/**
 * Create param for TransferStructures
 * @param {*} fiscalPeriodModel List fiscalPeriod
 * @param {*} fsStateModel State selected
 * @param {*} approvalFlowStatus ApprovalFlowStatus
 * @returns TransferStructuresRequestModel
 */
export const CreateParamTransferStructure = (fiscalPeriodModel, fsStateModel, approvalFlowStatus) => {
    let wiUser = new CookieAuthenModel().GetWILoginModel();
    let indexModel = new SelectedFiscalPeriodStateModel(fsStateModel);

    let targetFiscalPeriod = fiscalPeriodModel.GetFiscalPeriodsByIndex(indexModel.FiscalPeriodIndex);
    let accTypes = fiscalPeriodModel.GetTargetAccountingStandardTypes(indexModel.FiscalPeriodIndex).find(i => i.Value === fsStateModel.AccTypeIndex).Name;

    let targetFinancialStatementTypes = FinancialStatementTypes.map((item) => {
        if (fsStateModel.FsTypeIndex.includes(item.Value))
            return item.Name;
        return null;
    }).filter((el) => {
        return el !== null;
    });;

    let targetPeriodicValueGroups = targetFinancialStatementTypes.map((item) => {
        return new PeriodicAccountingItemGroup({
            YearToDate: targetFiscalPeriod.YearToDate,
            AccountingPeriod: targetFiscalPeriod.AccountingPeriod,
            TargetFinancialStatement: {
                AccountingStandardType: accTypes,
                ConsolidationType: ConsolidateType.NC,
                FinancialStatementType: item
            }
        });
    });

    return new TransferStructuresRequestModel({
        TransferStructuresRequest: new TransferStructuresRequest({
            AccessKey: wiUser.AccessKey,
            RequestKey: wiUser.RequestKey,
            PeriodicAccountingItemGroups: targetPeriodicValueGroups,

        }),
        CompanyId: storageModel.GetItem("CompanySelected").Id,
        ApprovalFlowStatus: approvalFlowStatus ? 1 : 0
    });
}